import { Subscription, PlayerDto } from '@toilet-paper-games/core';
import { makeAutoObservable } from 'mobx';

export class ControllerUserModel {
  active: boolean = false;
  timeWentInactive: number | null = null;
  hasConnection: boolean = false;

  screenName: string | null = null;
  image: string | null = null;
  isHost = false;
  subscription = Subscription.Free;

  networkReady = false;

  static fromDto(dto: ControllerUserDto): ControllerUserModel {
    const model = new ControllerUserModel(dto.id);
    model.updateFromDto(dto);
    return model;
  }

  constructor(public id: string) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  updateFromDto(dto: ControllerUserDto) {
    this.active = dto.active;
    this.timeWentInactive = dto.timeWentInactive;
    this.hasConnection = dto.hasConnection;
    this.image = dto.image;
    this.isHost = dto.isHost;
    this.screenName = dto.screenName;
    this.subscription = dto.subscription;
    this.networkReady = dto.networkReady;
  }

  /**
   * This is for when a new game is started.
   * @returns {Omit<PlayerDto, 'ready'>}
   */
  get playerInfo(): Omit<PlayerDto, 'ready'> {
    return {
      active: this.active,
      hasConnection: this.hasConnection,
      connectionId: this.id,
      image: this.image,
      isHost: this.isHost,
      screenName: this.screenName,
      subscription: this.subscription,
    };
  }
}

export interface ControllerUserDto {
  active: boolean;
  timeWentInactive: number | null;
  hasConnection: boolean;
  id: string;
  image: string | null;
  isHost: boolean;
  screenName: string | null;
  subscription: Subscription;
  networkReady: boolean;
}
